import { ListOfAuftragResponse } from './Api/ListOfAuftragResponse';

export class ContractEntity extends ListOfAuftragResponse {
    public static tryCast(o: any): ContractEntity {
        const ret = new ContractEntity();
        return Object.assign(ret, o);
    }
}
